import { render, staticRenderFns } from "./SendCommentDialogComponent.vue?vue&type=template&id=ac1095dc&"
import script from "./SendCommentDialogComponent.vue?vue&type=script&lang=js&"
export * from "./SendCommentDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports